import HomeContent from "./contents/HomeContent";

const Page = () => {
  return (
    <main className="flex flex-col w-full ">
      
      <HomeContent />
    </main>
  );
};

export default Page;
